import type { MeetingStatus } from "@performyard/models";

export const config = {
	defaultSortName: "startDateTime" as const,
	defaultSortDirection: "desc" as const,
	defaultPageNumber: 1,
	fallbackFilters: {
		status: [],
		privateNotes: "any" as const,
		meetingDateStart: undefined,
		meetingDateEnd: undefined,
	},
	pageSize: 25,
	meetingDescriptionMaxLength: 2000,
	statusOptions: ["active", "completed", "canceled", "archived"] as const,
	privateNotesOptions: ["any", "has-private-notes", "no-private-notes"] as const,
	columns: {
		name: { width: 488 },
		meetingDate: { width: 368 },
		agendaItems: { width: 120 },
		actionItems: { width: 120 },
		status: { width: 120 },
		control: { width: 40 },
	},
	layout: {
		breadcrumbMaxWidth: 146,
		pageHeaderMaxWidth: 1288,
		searchInputWidth: 288,
		datePickerWidth: 201,
	},
};

export const MEETING_STATUS_CONFIG: Record<
	MeetingStatus,
	{ label: string; color: "green" | "primary" | "red" | "neutral" }
> = {
	active: { label: "Active", color: "primary" },
	completed: { label: "Completed", color: "green" },
	canceled: { label: "Canceled", color: "red" },
	archived: { label: "Archived", color: "neutral" },
};
